import axios from "axios";
import { refreshJwtToken } from "../../helpers";
import { getCookie } from "../../helpers/Helpers";

const INT_API_BASE_URL = window.intAPIBaseUrl;
const INT_SUBSCRIPTION_KEY = window.intAPISubscriptionKey;
const CIAM_BASE_URL = window.ciamBaseUrl;
const CIAM_APP_CODE = window.ciamApplicationCode;

export const checkIfUserIsRegisteredToShopApp = async () => {
  const userProfile = JSON.parse(window.sessionStorage.getItem("userProfile"));

  if (
    !userProfile.applications.some(
      (app) => app.applicationCode === "anpost_onlineshop"
    )
  ) {
    await new Promise((resolve) => {
      window.m59.registerShopCustomer(() => {
        getProfile(getCookie("CIAMCustomerID")).then((res) => {
          if (res.status === 200) {
            sessionStorage.setItem("userProfile", JSON.stringify(res.data));
            resolve();
          }
        });
      });
    });
  }
};

const getProfile = async (uid) => {
  try {
    const res = await axios.get(`${CIAM_BASE_URL}/Profile/get?UID=${uid}`, {
      headers: {
        "ANP-APPLICATION-CODE": CIAM_APP_CODE,
        Authorization: `Bearer ${localStorage.getItem("JWTToken")}`,
        Pragma: "no-cache",
      },
    });
    return res;
  } catch (err) {
    console.error(err);
  }
};

export const getShopOrders = async () => {
  await checkIfUserIsRegisteredToShopApp();
  await refreshJwtToken();
  try {
    const getShopOrdersUrl = `${INT_API_BASE_URL}/shop/orders?limit=3&offset=0&pageInfo=false&order=desc`;
    const res = await axios.get(getShopOrdersUrl, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("JWTToken")}`,
        "ANP-SHOP-JWT": `Bearer ${getCookie("ANP-SHOP-JWT")}`,
        "Ocp-Apim-Subscription-Key": INT_SUBSCRIPTION_KEY,
      },
    });

    if (res.data) return { data: res.data, error: null };
    return { data: null, error: "Something went wrong." };
  } catch (error) {
    const message =
      error?.response?.data?.Message ||
      error?.message ||
      "Failed to get orders.";
    return { data: null, error: message };
  }
};
